var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatsureLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "297mm",
    height: "210mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 29700 21000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2466327659888"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "7978,11948 9531,9103 11082,11948 10483,11948 9532,10137 9052,11053 9546,11053 9306,11503 8815,11503 8582,11948 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "12090,11956 11586,11956 11586,9522 10638,9522 10638,9044 13037,9044 13037,9522 12090,9522 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "24100,9495 22246,9495 22246,11501 24100,11501 24100,11951 21750,11951 21750,9044 24100,9044 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "22572,10723 24008,10723 24008,10272 22572,10272 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7830 10776c-44,-103 -104,-193 -181,-270 -76,-76 -166,-137 -269,-180 -102,-44 -212,-66 -328,-66l-608 0c-51,0 -99,-9 -144,-28 -44,-19 -84,-45 -117,-79 -34,-34 -60,-73 -79,-119 -19,-45 -28,-93 -28,-145 0,-51 9,-99 28,-144 19,-44 45,-84 79,-117 33,-33 73,-60 117,-79 45,-19 93,-28 144,-28l1201 0 0 -476 -1201 0c-116,0 -226,23 -327,67 -102,44 -192,105 -269,182 -76,76 -137,166 -182,268 -44,102 -66,212 -66,327 0,116 22,227 67,329 44,102 105,193 181,269 77,77 167,138 269,182 101,44 211,67 327,67l608 0c50,0 99,9 144,28 44,19 84,46 117,79 33,33 60,73 79,117 19,45 28,93 28,144 0,51 -9,100 -28,145 -19,44 -46,83 -79,117 -33,33 -73,60 -117,78 -45,19 -94,29 -144,29l-1392 0 0 475 1392 0c116,0 226,-22 328,-66 102,-44 193,-106 269,-182 77,-76 137,-166 181,-268 44,-102 66,-212 66,-328 0,-116 -22,-226 -66,-328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M15500 10776c-44,-103 -104,-193 -181,-270 -76,-76 -166,-137 -269,-180 -102,-44 -212,-66 -328,-66l-608 0c-51,0 -99,-9 -144,-28 -44,-19 -84,-45 -117,-79 -34,-34 -60,-73 -79,-119 -19,-45 -28,-93 -28,-145 0,-51 9,-99 28,-144 19,-44 45,-84 79,-117 33,-33 73,-60 117,-79 45,-19 93,-28 144,-28l1201 0 0 -476 -1201 0c-116,0 -226,23 -327,67 -102,44 -192,105 -269,182 -76,76 -137,166 -182,268 -44,102 -66,212 -66,327 0,116 22,227 66,329 45,102 106,193 182,269 77,77 167,138 269,182 101,44 211,67 327,67l608 0c50,0 99,9 144,28 44,19 84,46 117,79 33,33 60,73 79,117 19,45 28,93 28,144 0,51 -9,100 -28,145 -19,44 -46,83 -79,117 -33,33 -73,60 -117,78 -45,19 -94,29 -144,29l-1392 0 0 475 1392 0c115,0 226,-22 328,-66 102,-44 193,-106 269,-182 77,-76 137,-166 181,-268 44,-102 66,-212 66,-328 0,-116 -22,-226 -66,-328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M19436 9498l834 0c264,0 477,214 477,477l0 0c0,264 -213,478 -477,478l-834 0 0 -955zm1324 2452l589 0 -781 -1095c368,-124 633,-472 633,-881l0 0c0,-514 -416,-930 -929,-930l-836 0 -251 0 -251 0 0 2907 502 0 0 -1048 584 0 740 1047z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M17904 9046l0 1703c0,393 -319,712 -713,712l0 0c-394,0 -713,-319 -713,-712l0 -1703 -484 0 0 1703c0,661 536,1196 1197,1196l0 0c661,0 1197,-535 1197,-1196l0 -1703 -484 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatsureLogoNew);
export default __webpack_public_path__ + "static/media/satsure-logo-new.d829f210aed111e546f7fa9748c60118.svg";
export { ForwardRef as ReactComponent };